import { render, staticRenderFns } from "./powerCut.vue?vue&type=template&id=23ab1fb4&scoped=true&"
import script from "./powerCut.vue?vue&type=script&lang=js&"
export * from "./powerCut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab1fb4",
  null
  
)

export default component.exports